/* Big Gun slide-out cart (sections/bgv2-cart-drawer.liquid).
   Spec: Strategy/2026-10/cart-drawer/Cart-Drawer-Strategy-and-Design-2026-10-03.md

   Vanilla, no jQuery. Every change goes through Shopify's Ajax cart (/cart/add.js,
   /cart/change.js, /cart/update.js) with Section Rendering, so one request returns
   the new drawer HTML and Shopify's own pixels keep firing. Adds made anywhere else
   on the site (vendor PDP form, card quick add, V2 buttons, apps) are seen through a
   PerformanceObserver on /cart/add and open the drawer.

   The upsell card comes from the shared brain (assets/bgv2-upsell.js, rules in
   snippets/bgv2-upsell-rules.liquid); this file feeds it the rider's session state:
     bgv2_up_skip    card keys the rider said No thanks to
     bgv2_tfi_skip   fit tags from "I already have a tune" (shared with the old net)
     bgv2_tfi_added  fit tags whose Power Box was added from an offer (shared)
     bgv2_cd_adds    adds from the cart this session (the gear card waits for 2)
     bgv2_cd_src     cart_upsell_src entries written this session
   Public: window.BGV2CD.open(), .close(), .refresh({ open: true }). */
(function () {
  'use strict';

  var SECTION = 'bgv2-cart-drawer';
  var root = document.querySelector('[data-bgv2-cd]');
  if (!root) return;
  var SURFACE = root.getAttribute('data-surface') || 'drawer';
  var IS_DRAWER = SURFACE === 'drawer';
  var CFG = window.BGV2 || {};
  var STR = (function () {
    var el = document.querySelector('[data-cd-strings]');
    try { return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; }
  })();
  var panel = root.querySelector('[data-cd-panel]');
  var isOpen = false;
  var lastTrigger = null;
  var selfUntil = 0;
  var seenPromo = {};

  document.body.classList.add('bgv2-cd-on');

  // ---------------------------------------------------------------- helpers
  function qs(sel, el) { return (el || root).querySelector(sel); }
  function qsa(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function fill(tpl, t) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) { return t && t[k] != null ? t[k] : ''; });
  }
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var parts = (Math.round(cents) / 100).toFixed(2).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount\w*\s*\}\}/g, parts.join('.')).replace(/<[^>]+>/g, '');
  }
  function track(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, params || {}); } catch (e) { /* ignore */ }
  }
  function ssList(key) {
    try { return (sessionStorage.getItem(key) || '').split('|').filter(Boolean); } catch (e) { return []; }
  }
  function ssAdd(key, val) {
    if (!val) return;
    try { var l = ssList(key); if (l.indexOf(val) < 0) l.push(val); sessionStorage.setItem(key, l.join('|')); } catch (e) { /* private mode */ }
  }
  function ssNum(key, inc) {
    var n = 0;
    try { n = parseInt(sessionStorage.getItem(key) || '0', 10) || 0; if (inc) { n += inc; sessionStorage.setItem(key, String(n)); } } catch (e) { /* ignore */ }
    return n;
  }
  function garage() {
    return window.BGE && window.BGE.Garage && typeof window.BGE.Garage.active === 'function' ? window.BGE.Garage : null;
  }
  function vehicleName(v) {
    if (!v) return '';
    return window.BGE && window.BGE.formatVehicle ? window.BGE.formatVehicle(v) : [v.year, v.make, v.model].filter(Boolean).join(' ');
  }
  function yearRange(tag) {
    var m = String(tag || '').trim().match(/^(\d{2}|\d{4})-(\d{2}|\d{4})$/);
    if (!m) return null;
    var f = function (y) { y = parseInt(y, 10); return y >= 100 ? y : (y <= 30 ? 2000 + y : 1900 + y); };
    return [f(m[1]), f(m[2])];
  }
  function yearIn(year, csv) {
    var y = parseInt(year, 10);
    if (isNaN(y)) return true;
    return String(csv || '').split(',').some(function (t) { var r = yearRange(t); return r && y >= r[0] && y <= r[1]; });
  }
  function itemFromEl(el, qty) {
    return {
      item_id: el.getAttribute('data-pn') || el.getAttribute('data-variant') || '',
      item_name: el.getAttribute('data-name') || '',
      price: (parseInt(el.getAttribute('data-price') || '0', 10) || 0) / 100,
      quantity: qty == null ? (parseInt(el.getAttribute('data-qty') || '1', 10) || 1) : qty
    };
  }
  function lineItems() { return qsa('[data-cd-line]').map(function (l) { return itemFromEl(l); }); }
  function subtotalCents() { var c = qs('[data-cd-content]'); return c ? parseInt(c.getAttribute('data-total') || '0', 10) || 0 : 0; }
  function announce(text) {
    var live = qs('[data-cd-live]');
    if (!live) return;
    live.textContent = '';
    setTimeout(function () { live.textContent = text; }, 50);
  }

  // ---------------------------------------------------------------- network
  function sectionsUrl() { return IS_DRAWER ? '/' : '/cart'; }
  function post(url, body, withSections) {
    if (withSections !== false) { body.sections = SECTION; body.sections_url = sectionsUrl(); }
    selfUntil = Date.now() + 8000;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).catch(function () { throw new Error(STR.err || 'Error'); }).then(function (r) { // offline: not "Failed to fetch" (CR-07)
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (!r.ok) { var err = new Error(j.description || j.message || STR.err || 'Error'); err.status = r.status; throw err; }
        return j;
      });
    });
  }
  var refreshing = null;
  var again = null;
  var lastRefresh = 0;
  function refresh(opts) {
    // A refresh asked for while one is in flight runs again afterwards, so a change made
    // mid-request is never lost; a request that hangs is aborted after 8 seconds.
    if (refreshing) { again = opts || {}; return refreshing; }
    lastRefresh = Date.now();
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 8000) : null;
    // no-store plus a throwaway parameter: a cached section response would show an old cart.
    // No Accept: application/json here: on /cart that header returns the cart JSON, not the section.
    refreshing = fetch(sectionsUrl() + '?sections=' + SECTION + '&_cd=' + Date.now(), { credentials: 'same-origin', cache: 'no-store', signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) { if (j) render(j[SECTION], Object.assign({}, opts, { fromRefresh: true })); })
      .catch(function (err) { if (window.console) console.warn('[bgv2-cd] refresh', err); /* keep what is on screen */ })
      .then(function () {
        clearTimeout(timer);
        refreshing = null;
        if (again) { var o = again; again = null; return refresh(o); }
      });
    return refreshing;
  }

  // ---------------------------------------------------------------- render
  function snapshot() {
    var m = {};
    qsa('[data-cd-line]').forEach(function (l) { m[l.getAttribute('data-key')] = parseInt(l.getAttribute('data-qty') || '0', 10); });
    return m;
  }
  // Which attributed kinds a rendered cart holds: a TFI Power Box line, a packing kit line.
  function lineKinds(el) {
    var lines = el ? Array.prototype.slice.call(el.querySelectorAll('[data-cd-line]')) : [];
    return {
      tfi: lines.some(function (l) { return l.getAttribute('data-family') === 'tfi'; }),
      pack: lines.some(function (l) { return /packing kit/i.test(l.getAttribute('data-name') || ''); })
    };
  }
  function render(html, opts) {
    opts = opts || {};
    // A null section in an Ajax response (Shopify could not render it in time) must not
    // leave the drawer stale: fall back to one plain refresh.
    if (!html) { if (!opts.fromRefresh) refresh(Object.assign({}, opts, { fromRefresh: true })); return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cd-content]');
    var cur = qs('[data-cd-content]');
    if (!fresh || !cur) return;
    var body = qs('[data-cd-body]');
    var scroll = body ? body.scrollTop : 0;
    var act = document.activeElement;
    var focus = null;
    if (act && root.contains(act)) {
      var fl = act.closest('[data-cd-line]');
      var attrs = ['data-cd-step', 'data-cd-qty', 'data-cd-remove', 'data-cd-drop-opt', 'data-cd-checkout'];
      for (var i = 0; i < attrs.length; i++) {
        if (act.hasAttribute(attrs[i])) {
          focus = (fl ? '[data-key="' + fl.getAttribute('data-key') + '"] ' : '') + '[' + attrs[i] + (attrs[i] === 'data-cd-step' ? '="' + act.getAttribute('data-cd-step') + '"' : attrs[i] === 'data-cd-drop-opt' ? '][value="' + act.value + '"' : '') + ']';
          break;
        }
      }
    }
    var prevCount = parseInt(cur.getAttribute('data-count') || '0', 10) || 0;
    var hadKinds = lineKinds(cur), hasKinds = lineKinds(fresh);
    cur.replaceWith(document.importNode(fresh, true));
    var count = parseInt(fresh.getAttribute('data-count') || '0', 10) || 0;
    if (prevCount > 0 && count === 0) post('/cart/update.js', { attributes: { cart_upsell_src: '', tfi_src: '', repack_src: '' } }, false).catch(function () {});
    else if (count > 0) {
      // The last Power Box or packing kit left a cart that still has other lines: its source attribute goes
      // with it, so the order does not credit an upsell it no longer carries (MP-08). cart_upsell_src stays,
      // as the log of adds.
      var gone = {};
      if (hadKinds.tfi && !hasKinds.tfi) gone.tfi_src = '';
      if (hadKinds.pack && !hasKinds.pack) gone.repack_src = '';
      if (gone.tfi_src === '' || gone.repack_src === '') post('/cart/update.js', { attributes: gone }, false).catch(function () {});
    }
    var cEl = qs('[data-cd-count]');
    if (cEl) { cEl.textContent = count; cEl.hidden = count === 0; }
    qsa('[data-cart-count]', document).forEach(function (el) { el.textContent = count; });
    // The phone cart link reads "Cart, 1 item" / "Cart, 2 items" (header-mobile).
    qsa('[data-cart-count-word]', document).forEach(function (el) { el.textContent = count === 1 ? ' item' : ' items'; });
    enhance(opts);
    var nb = qs('[data-cd-body]');
    if (nb) nb.scrollTop = opts.top ? 0 : scroll;
    if (focus) { var f = qs(focus); if (f && !f.disabled) f.focus(); else focusFirst(); }
    else if (act && root.contains(act) && !root.contains(document.activeElement)) focusFirst();
    document.dispatchEvent(new CustomEvent('bgv2:cart:rendered', { detail: { surface: SURFACE } }));
    document.dispatchEvent(new CustomEvent('bgv2:cart:change', { detail: { count: count, total: subtotalCents() } }));
  }

  // After every render: pinned new line, Garage fit lines, machine line, the card.
  function enhance(opts) {
    opts = opts || {};
    // An empty cart (first visit, after Remove, or back from checkout with a new cart)
    // starts the session ladder over, so attribution never leaks into the next order.
    var content = qs('[data-cd-content]');
    if (content && content.getAttribute('data-count') === '0') {
      try { ['bgv2_cd_src', 'bgv2_cd_adds', 'bgv2_up_skip'].forEach(function (k) { sessionStorage.removeItem(k); }); } catch (e) { /* ignore */ }
    }
    pinNew(opts.before);
    garageBits();
    tfiStatus();
    lastUps = renderUps();
    emptyBtn();
    applyOffline();
    affirmLine();
    placeNote();
    try {
      if (window.Shopify && window.Shopify.StorefrontExpressButtons && typeof window.Shopify.StorefrontExpressButtons.initialize === 'function') window.Shopify.StorefrontExpressButtons.initialize();
      if (window.Shopify && window.Shopify.PaymentButton && typeof window.Shopify.PaymentButton.init === 'function') window.Shopify.PaymentButton.init();
    } catch (e) { /* wallets stay as rendered */ }
    watchWallets();
  }

  // Phones under 400px (FL1-17): the footer note (ship, warranty and Affirm, up to four lines at 360px) moves to the
  // end of the scroll body, under the line items and the card, so the card's add clears the pinned footer at 360x800
  // and 375x812. The footer keeps the subtotal and Check out; every word of the note stays, one scroll away.
  var NARROW = window.matchMedia ? window.matchMedia('(max-width: 399px)') : null;
  function placeNote() {
    if (!IS_DRAWER) return;
    var foot = qs('[data-cd-foot]'), body = qs('[data-cd-body]'), note = qs('.bgv2-cd__note-line');
    if (!foot || !body || !note) return;
    var aff = qs('[data-cd-affirm]'), holder = qs('[data-cd-note-body]');
    if (NARROW && NARROW.matches) {
      if (!holder) {
        holder = document.createElement('div');
        holder.className = 'bgv2-cd__note-body';
        holder.setAttribute('data-cd-note-body', '');
      }
      if (holder.parentNode !== body || holder !== body.lastElementChild) body.appendChild(holder);
      if (note.parentNode !== holder) holder.appendChild(note);
      if (aff && aff.parentNode !== holder) holder.appendChild(aff);
      holder.classList.toggle('has-affirm', foot.classList.contains('has-affirm'));
    } else if (holder) {
      var sub = qs('.bgv2-cd__sub', foot);
      if (sub) { sub.parentNode.insertBefore(note, sub.nextSibling); if (aff) note.parentNode.insertBefore(aff, note.nextSibling); }
      holder.remove();
    }
  }
  if (NARROW) {
    var onNarrow = function () { placeNote(); };
    if (typeof NARROW.addEventListener === 'function') NARROW.addEventListener('change', onNarrow);
    else if (typeof NARROW.addListener === 'function') NARROW.addListener(onNarrow);
  }

  // Affirm (CD-04): the footer shows the plain "Pay over time with Affirm." link until
  // Affirm.js is on the page; then Affirm's own "as low as" amount takes its place.
  function affirmLine() {
    var el = qs('[data-cd-affirm]');
    var on = !!(el && window.affirm && window.affirm.ui && typeof window.affirm.ui.refresh === 'function');
    var foot = qs('[data-cd-foot]');
    if (foot) foot.classList.toggle('has-affirm', on);
    if (!on) return;
    el.hidden = false;
    try { window.affirm.ui.refresh(); } catch (e) { /* the link line stays */ }
  }

  // Wallets (CD-03): Shopify draws grey placeholder bars until the buttons load, four
  // high on a slow line. The CSS holds the box to one 48px row until real buttons sit
  // in it; then .is-ready lets a second row (Apple Pay on an iPhone) show.
  // Ready = Shopify's wallet elements (shop-pay-wallet-button, shopify-paypal-button,
  // shopify-google-pay-button...) are in and its placeholder grid is gone. The
  // placeholder rows carry role="button" too, so that is not a signal.
  var walletObs = null;
  function walletButtons(w) { return qsa('*', w).filter(function (el) { return /-button$/i.test(el.tagName); }); }
  function walletsReady(w) {
    if (w.querySelector('.wallet-cart-grid, .wallet-cart-button-container')) return false;
    return walletButtons(w).length > 0;
  }
  // Rows of real buttons, so the box is not held open by PayPal's hidden menu frames.
  function walletRows(w) {
    var tops = [];
    walletButtons(w).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height < 8) return;
      var top = Math.round(r.top);
      if (!tops.some(function (x) { return Math.abs(x - top) < 8; })) tops.push(top);
    });
    return tops.length;
  }
  function watchWallets() {
    var w = qs('[data-cd-wallets]');
    if (walletObs) { walletObs.disconnect(); walletObs = null; }
    if (!w) return;
    var check = function () {
      if (!walletsReady(w)) return false;
      var size = function () {
        var rows = walletRows(w);
        if (rows) w.style.setProperty('--cd-wallet-rows', rows); else w.style.removeProperty('--cd-wallet-rows');
      };
      size();
      w.classList.add('is-ready');
      // button heights can settle a moment after they appear
      setTimeout(size, 1000); setTimeout(size, 3000);
      if (walletObs) { walletObs.disconnect(); walletObs = null; }
      return true;
    };
    if (check() || !('MutationObserver' in window)) return;
    walletObs = new MutationObserver(check);
    walletObs.observe(w, { childList: true, subtree: true, attributes: true });
    // shadow DOM changes do not reach the observer: poll a few times as well
    var n = 0;
    (function poll() { if (!w.isConnected || w.classList.contains('is-ready') || n++ > 40) return; if (!check()) setTimeout(poll, 500); })();
  }

  function pinNew(before) {
    if (!before) return;
    var list = qs('[data-cd-lines]');
    if (!list) return;
    var news = qsa('[data-cd-line]').filter(function (l) {
      var k = l.getAttribute('data-key');
      return !(k in before) || parseInt(l.getAttribute('data-qty') || '0', 10) > before[k];
    });
    for (var i = news.length - 1; i >= 0; i--) {
      list.insertBefore(news[i], list.firstChild);
      news[i].classList.add('is-new');
    }
    if (news.length) {
      var n = news[0];
      announce(fill(STR.added_sr, { title: n.getAttribute('data-name'), subtotal: money(subtotalCents()) }));
      setTimeout(function () { news.forEach(function (l) { l.classList.remove('is-new'); }); }, 2400);
    }
  }

  function garageBits() {
    var g = garage();
    var v = g ? g.active() : null;
    var vn = vehicleName(v);
    // Fit line on each vehicle-specific line, checked against every saved machine (the
    // active one wins a tie), so a part for the rider's second machine says so (CD-10).
    var vlines = 0, ticked = 0;
    qsa('[data-cd-line]').forEach(function (l) {
      var p = qs('[data-cd-fit]', l);
      if (!p) return;
      var tags = l.getAttribute('data-tags') || '';
      if (!v || tags.indexOf('fit_') < 0) { p.hidden = true; return; }
      vlines++;
      var best = typeof g.best === 'function' ? g.best(tags) : null;
      var st = best ? best.state : g.fits(tags);
      var bn = best && best.vehicle ? vehicleName(best.vehicle) : vn;
      if (st === 'fits') {
        p.className = 'bgv2-cd__fit';
        p.innerHTML = tickSvg() + '<span>' + esc(fill(STR.fit_ok, { machine: bn })) + '</span>';
        p.hidden = false;
        ticked++;
      } else if (st === 'wrong_year') {
        p.className = 'bgv2-cd__fit is-warn';
        p.innerHTML = warnSvg() + '<span>' + esc(fill(STR.fit_year, { machine: bn })) + '</span>';
        p.hidden = false;
      } else if (st === 'no_fit' && STR.fit_no) {
        // never red and never a block: the rider may know better than the tags
        p.className = 'bgv2-cd__fit is-warn';
        p.innerHTML = warnSvg() + '<span>' + esc(fill(STR.fit_no, { machine: vn })) + '</span>';
        p.hidden = false;
      } else {
        p.hidden = true;
      }
    });
    // machine names in the machine line and the tuner card
    var mline = qs('[data-cd-machine]');
    // Every vehicle line already says "Fits your ...": the machine line would only repeat
    // it (CD-01, CD-11), so it steps aside and the card moves up.
    if (mline) mline.hidden = vlines > 0 && ticked === vlines;
    var mine = v && mline && g.fits(mline.getAttribute('data-tags') || '') === 'fits';
    qsa('[data-bgv2-machine]').forEach(function (m) {
      if (!m.hasAttribute('data-orig')) m.setAttribute('data-orig', m.textContent);
      m.textContent = mine ? vn : m.getAttribute('data-orig');
    });
    // "For the Yamaha Raptor 700" until a saved machine fits the pipe, then "For your ..." (FL1-42, FL3-14).
    if (mline) qsa('[data-bgv2-your]', mline).forEach(function (y) { y.textContent = mine ? 'your' : 'the'; });
    var mb = qs('[data-cd-machine-btn]');
    if (mb) mb.textContent = v ? (mb.getAttribute('data-l-change') || STR.change) : STR.save;
  }
  function tickSvg() { return '<svg class="bgv2-ico" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M8.3 14.2 4.1 10l1.5-1.5 2.7 2.7 6-6L15.8 6.7z"/></svg>'; }
  function warnSvg() { return '<svg class="bgv2-ico" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><path d="M10 2 1 18h18L10 2zm-1 6h2v5H9V8zm0 6h2v2H9v-2z"/></svg>'; }

  // "Power Box added": a TFI line in the cart whose fit tags hold a fit the rider added a box for.
  function tfiStatus() {
    var st = qs('[data-cd-tfi-added]');
    if (!st) return;
    var added = ssList('bgv2_tfi_added');
    st.hidden = !qsa('[data-cd-line][data-family="tfi"]').some(function (l) {
      var tags = '|' + (l.getAttribute('data-tags') || '') + '|';
      return added.some(function (f) { return tags.indexOf('|' + f + '|') >= 0; });
    });
  }

  // The card: the shared brain (assets/bgv2-upsell.js) picks it from the rules table and
  // the facts the section rendered; the drawer only adds its session state.
  // Returns the offer drawn, or a promise of it while the brain fetches pipe data. The
  // facts are read once per render and kept on the content element, so a No thanks
  // re-draws from the same (already enriched) data without fetching again (CD-08).
  var current = null;
  var lastUps = null; // what the last enhance() drew: an offer, null, or a promise of one
  function renderUps() {
    var box = qs('[data-cd-ups]');
    current = null;
    if (!box || !window.BGV2Upsell) return null;
    var U = window.BGV2Upsell;
    var content = qs('[data-cd-content]');
    if (!content) return null;
    if (!content.__ups) content.__ups = U.read(content);
    var data = content.__ups;
    if (data && U.needsEnrich && U.needsEnrich(data).length) {
      box.innerHTML = '';
      return U.enrich(data).then(function () {
        if (content !== qs('[data-cd-content]')) return null;
        return drawUps(box, data);
      });
    }
    return drawUps(box, data);
  }
  function drawUps(box, data) {
    var U = window.BGV2Upsell;
    var list = U.offers(data, {
      surface: SURFACE,
      skip: ssList('bgv2_up_skip'),
      skipFits: ssList('bgv2_tfi_skip'),
      adds: ssNum('bgv2_cd_adds')
    });
    if (list.length) {
      current = list[0];
      current.__prior = (data && data.ctx && data.ctx.upsell_src) || '';
      var soft1 = U.softLink(data, { surface: SURFACE });
      box.innerHTML = U.card(current, { skip: true }) + (soft1 ? '<p class="bgv2-up__soft"><a class="bgv2-textlink" href="' + esc(soft1.url) + '">' + esc(soft1.text) + '</a></p>' : '');
      U.bind(box.firstElementChild, current);
      if (isOpen || !IS_DRAWER) promoView(current);
      return current;
    }
    var soft = U.softLink(data, { surface: SURFACE });
    box.innerHTML = soft ? '<p class="bgv2-up__soft"><a class="bgv2-textlink" href="' + esc(soft.url) + '">' + esc(soft.text) + '</a></p>' : '';
    return null;
  }
  function promoView(o) {
    if (!o || seenPromo[o.key] || !window.BGV2Upsell) return;
    seenPromo[o.key] = 1;
    window.BGV2Upsell.promoView(o, SURFACE);
  }

  // ---------------------------------------------------------------- empty state
  function emptyBtn() {
    var b = qs('[data-cd-empty-btn]');
    if (!b) return;
    var g = garage(), v = g ? g.active() : null;
    var url = v && window.BGE && typeof window.BGE.browseUrl === 'function' ? window.BGE.browseUrl(v) : '';
    // "Tell us what you ride" is only for riders with no machine saved; the button names it otherwise (ST-08).
    // A legacy model-less machine gets the Garage's own prompt to pick its model, as the bar and drawer do (FL2-19).
    var legacy = !v && g && typeof g.needsModel === 'function' ? g.needsModel()[0] : null;
    var line = qs('[data-cd-empty-p]');
    if (line) {
      if (line._bgeText == null) line._bgeText = line.textContent;
      line.textContent = legacy ? 'Your ' + vehicleName(legacy) + ' needs a model before we can show the parts that fit.' : line._bgeText;
      line.hidden = !!(v && url);
    }
    b.removeAttribute('data-id');
    if (v && url) {
      b.removeAttribute('data-bge-action');
      b.setAttribute('data-cd-href', url);
      b.textContent = fill(b.getAttribute('data-l-known') || STR.empty_btn_known, { machine: vehicleName(v) });
    } else if (legacy) {
      b.setAttribute('data-bge-action', 'pick-model');
      b.setAttribute('data-id', legacy.id);
      b.removeAttribute('data-cd-href');
      b.textContent = 'Pick the model of your ' + vehicleName(legacy);
    } else {
      b.setAttribute('data-bge-action', 'open-drawer');
      b.removeAttribute('data-cd-href');
      b.textContent = STR.empty_btn || b.textContent;
    }
  }

  // ---------------------------------------------------------------- actions
  var qtyTimers = {};
  function setQty(line, q) {
    var key = line.getAttribute('data-key');
    var old = parseInt(line.getAttribute('data-qty') || '0', 10) || 0;
    q = Math.max(0, parseInt(q, 10) || 0);
    var input = qs('[data-cd-qty]', line);
    if (input) input.value = q;
    var unit = parseInt(line.getAttribute('data-unit') || '0', 10) || 0;
    var price = qs('[data-cd-line-price]', line);
    if (price && unit) price.textContent = money(unit * q);
    var minus = qs('[data-cd-step="-1"]', line);
    if (minus) minus.disabled = q <= 1;
    line.classList.add('is-busy');
    line.setAttribute('aria-busy', 'true');
    clearTimeout(qtyTimers[key]);
    qtyTimers[key] = setTimeout(function () {
      var before = snapshot();
      post('/cart/change.js', { id: key, quantity: q }).then(function (j) {
        var delta = q - old;
        var it = itemFromEl(line, Math.abs(delta));
        if (delta > 0) track('add_to_cart', { currency: CFG.currency || 'USD', value: it.price * it.quantity, items: [it] });
        else if (delta < 0) track('remove_from_cart', { currency: CFG.currency || 'USD', value: it.price * it.quantity, items: [it] });
        render(j.sections && j.sections[SECTION], { before: q > old ? null : before });
        announce(fill(STR.updated_sr, { subtotal: money(subtotalCents()) }));
      }).catch(function (err) {
        line.classList.remove('is-busy');
        line.removeAttribute('aria-busy');
        var e = qs('[data-cd-err]', line);
        refresh().then(function () {
          var nl = qs('[data-key="' + key + '"]');
          var ne = nl ? qs('[data-cd-err]', nl) : e;
          if (!ne) return;
          // 422 over stock: Shopify's text says "added", but nothing was; say what changed (CD-07).
          var nq = nl ? parseInt(nl.getAttribute('data-qty') || '0', 10) || 0 : 0;
          var msg = err.status === 422 && nq > 0 && nq < q && STR.max_qty ? fill(STR.max_qty, { n: nq }) : (err.message || STR.err);
          ne.textContent = msg;
          ne.hidden = false;
        });
      });
    }, 350);
  }

  function addFromCard(btn) {
    var ids = String(btn.getAttribute('data-up-add') || '').split(',').filter(Boolean);
    if (!ids.length || btn.getAttribute('aria-busy') === 'true' || !window.BGV2Upsell) return;
    var cardEl = btn.closest('.bgv2-up');
    var o = (cardEl && cardEl.__offer) || current || {};
    var U = window.BGV2Upsell;
    var first = o.items && o.items[0];
    // a year choice (no machine, several boxes) reports the box it adds
    var ci = btn.getAttribute('data-up-i');
    if (ci !== null && o.choices && o.choices[+ci]) first = o.choices[+ci].box;
    var it = first ? { item_id: first.pn || String(first.v), item_name: first.t, price: (first.p || 0) / 100, quantity: 1 } : { item_id: ids[0] };
    // RV2-C1: disabling the focused button would drop focus to <body>, and the re-render
    // replaces the card. Park focus on the panel (it survives the render and shows no
    // ring), then land on the next card's heading, or the added line when no card follows.
    var hadFocus = document.activeElement === btn;
    var hold = panel || root;
    if (hadFocus) { if (!hold.hasAttribute('tabindex')) hold.setAttribute('tabindex', '-1'); hold.focus(); }
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    track('select_promotion', { promotion_id: 'up_' + String(o.step || 'card').replace(':', '_'), creative_slot: o.state || o.kind, location_id: SURFACE, items: [it] });
    var before = snapshot();
    selfUntil = Date.now() + 8000;
    var altSrc = btn.getAttribute('data-up-src');
    U.addToCart(ids.join(','), { src: altSrc || o.src, surface: SURFACE, fit: o.fit, prior: o.__prior, swap: altSrc ? null : o.swap, sections: SECTION, sections_url: sectionsUrl() }).then(function (j) {
      track('add_to_cart', { currency: CFG.currency || 'USD', value: it.price, item_list_id: 'up_' + SURFACE, items: [it] });
      render(j.sections && j.sections[SECTION], { before: before, top: true });
      if (!hadFocus) return;
      Promise.resolve(lastUps).catch(function () { return null; }).then(function (next) {
        if (document.activeElement !== hold && root.contains(document.activeElement)) return; // the rider moved on
        var box = qs('[data-cd-ups]');
        var target = (next && box && box.querySelector('.bgv2-up__h, .bgv2-up__eyebrow')) ||
          qs('[data-cd-line].is-new .bgv2-cd__name') || qs('[data-cd-line] .bgv2-cd__name') || qs('[data-cd-checkout]');
        if (!target) return;
        if (!target.matches('a[href], button')) target.setAttribute('tabindex', '-1');
        target.focus();
      });
    }).catch(function (err) {
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
      if (hadFocus) btn.focus();
      var lab = btn.querySelector('[data-up-label]');
      if (lab) lab.textContent = err.message || STR.err;
      refresh();
    });
  }

  function skipCard(btn) {
    var cardEl = btn.closest('.bgv2-up');
    var o = (cardEl && cardEl.__offer) || current;
    if (!o) return;
    ssAdd('bgv2_up_skip', o.key);
    if (o.kind === 'tfi' || o.kind === 'rev') ssAdd('bgv2_tfi_skip', o.fit);
    track('cart_upsell_skip', { card: o.kind, fit: o.fit || '' });
    if (o.kind === 'tfi') track('tfi_dismiss', { fit: o.fit || '' });
    // Focus the next card's heading once it is drawn (after any fetch), else Check out.
    Promise.resolve(renderUps()).then(function (next) {
      var box = qs('[data-cd-ups]');
      var target = next && box ? box.querySelector('.bgv2-up__h, .bgv2-up__eyebrow') : qs('[data-cd-checkout]');
      if (target) { if (!target.matches('button')) target.setAttribute('tabindex', '-1'); target.focus(); }
    }).catch(function () { var c = qs('[data-cd-checkout]'); if (c) c.focus(); });
  }

  function dropShip(input) {
    var box = input.closest('[data-cd-drop]');
    if (!box || box.getAttribute('aria-busy') === 'true') return;
    var fee = box.getAttribute('data-fee-variant');
    var drop = input.value === 'drop';
    var has = !!qs('[data-cd-line][data-variant="' + fee + '"]');
    box.setAttribute('aria-busy', 'true');
    var step = Promise.resolve();
    if (drop && !has) step = post('/cart/add.js', { items: [{ id: parseInt(fee, 10), quantity: 1 }] }, false);
    else if (!drop && has) step = post('/cart/change.js', { id: String(fee), quantity: 0 }, false);
    step.then(function () {
      return post('/cart/update.js', { attributes: { 'Drop Ship': drop ? 'Yes' : 'No' } });
    }).then(function (j) {
      render(j.sections && j.sections[SECTION]);
    }).catch(function () {
      box.removeAttribute('aria-busy');
      refresh();
    });
  }

  // ---------------------------------------------------------------- open / close
  var savedOverflow = '';
  function lockScroll(on) {
    var h = document.documentElement;
    if (on) {
      var gap = window.innerWidth - h.clientWidth;
      savedOverflow = h.style.overflow;
      h.style.overflow = 'hidden';
      if (gap > 0) document.body.style.paddingRight = gap + 'px';
    } else {
      h.style.overflow = savedOverflow;
      document.body.style.paddingRight = '';
    }
  }
  function focusables() {
    return qsa('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), textarea, select, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null || el === document.activeElement; });
  }
  function focusFirst() {
    var c = qs('.bgv2-cd__close');
    if (c) c.focus(); else if (panel) panel.focus();
  }
  function open(opts) {
    opts = opts || {};
    if (!IS_DRAWER) { root.scrollIntoView({ behavior: window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' }); return; }
    var wasOpen = isOpen;
    if (!isOpen) {
      lastTrigger = opts.trigger || document.activeElement;
      root.hidden = false;
      void root.offsetWidth;
      root.classList.add('is-open');
      document.body.classList.add('open_Cart', 'bgv2-cd-open');
      lockScroll(true);
      isOpen = true;
      seenPromo = {};
      setTimeout(focusFirst, 30);
      if (lineItems().length) track('view_cart', { currency: CFG.currency || 'USD', value: subtotalCents() / 100, items: lineItems() });
      document.dispatchEvent(new CustomEvent('bgv2:cart:open'));
    }
    // The skeleton only bridges a closed drawer to its first render; an open drawer
    // already shows the cart and just updates in place.
    if (opts.skeleton && !wasOpen) addSkeleton();
    if (current) promoView(current);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    document.body.classList.remove('open_Cart', 'bgv2-cd-open');
    lockScroll(false);
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    setTimeout(function () { if (!isOpen) root.hidden = true; }, reduce ? 0 : 200);
    if (lastTrigger && typeof lastTrigger.focus === 'function' && document.contains(lastTrigger)) lastTrigger.focus();
    document.dispatchEvent(new CustomEvent('bgv2:cart:close'));
  }
  function addSkeleton() {
    if (qs('.bgv2-cd__skel')) return;
    var list = qs('[data-cd-lines]');
    var li = document.createElement('li');
    li.className = 'bgv2-cd__skel';
    li.setAttribute('aria-hidden', 'true');
    li.innerHTML = '<i class="img"></i><i style="width:85%"></i><i style="width:45%"></i><i style="width:60%"></i>';
    if (list) list.insertBefore(li, list.firstChild);
    else { var b = qs('.bgv2-cd__body'); if (b) b.insertBefore(li, b.firstChild); }
    setTimeout(function () { if (li.parentNode) li.parentNode.removeChild(li); }, 5000);
  }

  // ---------------------------------------------------------------- offline
  function applyOffline() {
    var off = navigator.onLine === false;
    root.classList.toggle('is-offline', off);
    var banner = qs('[data-cd-offline]');
    if (banner) banner.hidden = !off;
    qsa('[data-cd-step], [data-up-add], [data-cd-qty], [data-cd-drop-opt]').forEach(function (el) {
      if (off) { el.setAttribute('data-cd-off', '1'); el.disabled = true; }
      else if (el.getAttribute('data-cd-off')) { el.removeAttribute('data-cd-off'); el.disabled = false; }
    });
    var co = qs('[data-cd-checkout]');
    if (co) co.setAttribute('aria-disabled', off ? 'true' : 'false');
  }
  window.addEventListener('online', function () { applyOffline(); refresh(); });
  window.addEventListener('offline', applyOffline);

  // ---------------------------------------------------------------- events
  root.addEventListener('click', function (e) {
    var t = e.target;
    var el;
    if ((el = t.closest('[data-cd-close]'))) { e.preventDefault(); close(); return; }
    if ((el = t.closest('[data-cd-step]'))) {
      var line = el.closest('[data-cd-line]');
      if (line) setQty(line, (parseInt((qs('[data-cd-qty]', line) || {}).value || line.getAttribute('data-qty'), 10) || 0) + parseInt(el.getAttribute('data-cd-step'), 10));
      return;
    }
    if ((el = t.closest('[data-cd-remove]'))) {
      e.preventDefault();
      var rl = el.closest('[data-cd-line]');
      if (rl) setQty(rl, 0);
      return;
    }
    if ((el = t.closest('[data-up-add]'))) { e.preventDefault(); addFromCard(el); return; }
    if ((el = t.closest('[data-up-skip]'))) { e.preventDefault(); skipCard(el); return; }
    if ((el = t.closest('[data-cd-checkout]'))) {
      if (el.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
      track('begin_checkout', { currency: CFG.currency || 'USD', value: subtotalCents() / 100, items: lineItems() });
      return;
    }
    if ((el = t.closest('[data-cd-href]'))) { e.preventDefault(); window.location.href = el.getAttribute('data-cd-href'); return; }
    if ((el = t.closest('[data-bge-action="open-drawer"]'))) { if (IS_DRAWER) { lastTrigger = null; close(); } return; }
    if (t.closest('a[href]') && IS_DRAWER && !t.closest('[data-cd-remove]')) { /* plain links (product titles) navigate */ }
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-cd-qty]')) { var line = t.closest('[data-cd-line]'); if (line) setQty(line, t.value); return; }
    if (t.matches('[data-cd-drop-opt]') && t.checked) dropShip(t);
  });
  root.addEventListener('keydown', function (e) {
    if (e.target.matches && e.target.matches('[data-cd-qty]') && e.key === 'Enter') { e.preventDefault(); e.target.blur(); }
  });
  document.addEventListener('keydown', function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables();
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Header cart icons (desktop and phone) open the drawer instead of the vendor mini cart.
  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-cart-preview-pc], [data-cart-preview]');
    if (!t) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (IS_DRAWER) { refresh(); open({ trigger: t }); }
    else root.scrollIntoView({ behavior: window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
  }, true);

  // Adds made anywhere else on the page.
  var extTimer = null;
  function onExternalAdd() {
    clearTimeout(extTimer);
    var before = snapshot();
    if (IS_DRAWER) open({ skeleton: true });
    extTimer = setTimeout(function () { refresh({ before: before, top: true }); }, 120);
  }
  // Adds that announce themselves (the PDP form, V2 buttons): open now, and render the
  // drawer straight from the add response when the caller asked for
  // sections=bgv2-cart-drawer, so there is no second request.
  var lastEventAt = 0;
  document.addEventListener('bgv2:cart:added', function (e) {
    var d = (e && e.detail) || {};
    lastEventAt = Date.now();
    clearTimeout(extTimer);
    var before = snapshot();
    var html = d.sections && d.sections[SECTION];
    if (IS_DRAWER && d.open !== false) open({ skeleton: !html });
    if (html) render(html, { before: before, top: true });
    else refresh({ before: before, top: true });
  });
  // A theme add (PDP, V3 card) says so before it posts, so the observer below does not open the
  // drawer for a request that may fail: a 422 keeps the shopper on the card's message (CR-05).
  document.addEventListener('bgv2:cart:adding', function () { selfUntil = Date.now() + 8000; });
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (en) {
          if (!/\/cart\/add(\.js)?(\?|$)/.test(en.name)) return;
          if (Date.now() < selfUntil || Date.now() - lastEventAt < 2500) return;
          onExternalAdd();
        });
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* older browsers: V2 adds still call BGV2CD.refresh */ }
  }

  // Back from a cached page or another tab: the cart may have changed.
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });
  // A closed drawer refreshes on return only when its last refresh is 30 s old (CD-17).
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'visible') return;
    if (!IS_DRAWER || isOpen || Date.now() - lastRefresh >= 30000) refresh();
  });

  // Garage loads deferred: re-run the Garage-dependent parts when it is ready and on change.
  (function whenGarage(tries) {
    var g = garage();
    if (g) {
      garageBits(); renderUps(); emptyBtn();
      if (typeof g.onChange === 'function') g.onChange(function () { garageBits(); renderUps(); emptyBtn(); });
      return;
    }
    if (tries < 25) setTimeout(function () { whenGarage(tries + 1); }, 200);
  })(0);

  enhance();

  window.BGV2CD = {
    open: open,
    close: close,
    refresh: function (opts) {
      opts = opts || {};
      var before = snapshot();
      if (opts.open && IS_DRAWER) open({ skeleton: true });
      return refresh({ before: before, top: true });
    }
  };
  window.BGV2 = window.BGV2 || {};
  window.BGV2.CartDrawer = window.BGV2CD;
})();
